import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Config from './base/config/Config';

const files = Config.langFiles;

var resources = {};

for (var lang in files) {
    resources[`${lang}`] = {
        translation: files[`${lang}`]
    };
}

i18n
    .use(initReactI18next)
    .init({
        debug: false,
        resources,
        fallbackLng: Config.mainLang,
        saveMissing: false,
        keySeparator: false,
        interpolation: { escapeValue: false },
        react: { useSuspense: false },
        i18n: { seo: true },
        nsSeparator: '::'
    });

export default i18n;
